import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import UnifiedTaskList from '../../components/tasks/UnifiedTaskList';

const TasksPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine active tab based on current route
  const activeTab = location.pathname === '/tasks/me' ? 1 : 0;

  const handleTabChange = (event, newValue) => {
    if (newValue === 0) {
      navigate('/tasks');
    } else {
      navigate('/tasks/me');
    }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="All Tasks" />
          <Tab label="My Assigned Tasks" />
        </Tabs>
      </Box>
      <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
        {activeTab === 0 ? (
          <UnifiedTaskList viewMode="all" groupBySections={false} showProject={true} />
        ) : (
          <UnifiedTaskList viewMode="my" groupBySections={false} showProject={true} />
        )}
      </Box>
    </Box>
  );
};

export default TasksPage;